import axios from 'axios';
import { SKW_URL } from '../utils/constants';

const api = axios.create({
  baseURL: SKW_URL,
});

export default api;
